import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/logo.svg';
import menuIcon from '../../assets/images/manue.svg';
import LoginModal from '../ui/LoginModal';
import AdminSignUpModale from '../ui/AdminSignUpModale';
import AdminLoginModal from '../ui/AdminLoginModel';
import SignUpModale from '../ui/SignUpModale';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [signUpModalOpen, setSignUpModalOpen] = useState(false);
  const [isAdminLoginOpen, setIsAdminLoginOpen] = useState(false);
  const [isAdminSignUpOpen, setIsAdminSignUpOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Toggle functions for modals
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const toggleSignUpModal = () => {
    setIsModalOpen(false);
    setSignUpModalOpen(!signUpModalOpen);
  };
  const toggleAdminLogin = () => setIsAdminLoginOpen(!isAdminLoginOpen);
  const toggleAdminSignUp = () => setIsAdminSignUpOpen(!isAdminSignUpOpen);

  // Close functions for modals
  const closeModal = () => setIsModalOpen(false);
  const closeAdminLogin = () => setIsAdminLoginOpen(false);
  const closeAdminSignUp = () => setIsAdminSignUpOpen(false);

  // Function to toggle mobile menu
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  return (
    <nav className="bg_header">
      <div className="flex py-2 justify-between items-center mx-4">
        <img src={logo} alt="logo" className="w-8 h-8 md:w-12 md:h-12 lg:w-auto lg:h-auto" />

        {/* Desktop Menu */}
        <div className="items-center hidden lg:flex">
          {location.pathname !== '/organization' && (
            <Link to="/">Home</Link>
          )}
          <Link to="/how-it-works">How It Works</Link>

          {(location.pathname === '/organization' || location.pathname === '/organization/message') && (
            <>
              <Link to="/organization">Organizations</Link>
              <Link to="/organization/message">Message</Link>
              <Link to="/organization/dashboard" style={{ marginRight: 0 }}>Dashboard</Link>
            </>
          )}

          {(location.pathname === '/volunteer' || location.pathname === '/volunteer/message') && (
            <>
              <Link to="/volunteer/message">Message</Link>
              <Link to="/volunteer/dashboard" style={{ marginRight: 0 }}>Volunteer</Link>
            </>
          )}

          {location.pathname === '/' && (
            <>
              <button
                onClick={toggleModal}
                type="button"
                className="nav_btn_color mr-8 py-1 px-8 rounded-lg"
              >
                Log In
              </button>
              <button className="nav_btn_color py-1 px-8 rounded-lg" onClick={toggleSignUpModal}>
                Sign Up
              </button>
            </>
          )}
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg_header fixed top-0 left-0 w-full  h-fit z-50 flex flex-col items-center p-6">
            <button
              className="self-end mb-6 text-gray-500"
              onClick={toggleMobileMenu}
            >
              X {/* Close button for mobile menu */}
            </button>

            {location.pathname !== '/organization' && (
              <Link to="/" onClick={toggleMobileMenu}>Home</Link>
            )}
            <Link to="/how-it-works" onClick={toggleMobileMenu}>How It Works</Link>

            {(location.pathname === '/organization' || location.pathname === '/organization/message') && (
              <>
                <Link to="/organization" onClick={toggleMobileMenu}>Organizations</Link>
                <Link to="/organization/message" onClick={toggleMobileMenu}>Message</Link>
                <Link to="/organization/dashboard" onClick={toggleMobileMenu}>Dashboard</Link>
              </>
            )}

            {(location.pathname === '/volunteer' || location.pathname === '/volunteer/message') && (
              <>
                <Link to="/volunteer/message" onClick={toggleMobileMenu}>Message</Link>
                <Link to="/volunteer/dashboard" onClick={toggleMobileMenu}>Volunteer</Link>
              </>
            )}

            {location.pathname === '/' && (
              <>
                <button
                  onClick={() => {
                    toggleModal();
                    toggleMobileMenu();
                  }}
                  type="button"
                  className="nav_btn_color my-4 py-2 px-8 rounded-xl"
                >
                  Log In
                </button>
                <button
                  className="nav_btn_color py-2 px-8 rounded-xl"
                  onClick={() => {
                    toggleSignUpModal();
                    toggleMobileMenu();
                  }}
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
        )}


        {/* Mobile Menu Toggle */}
        <img
          src={menuIcon}
          alt="menu"
          className="w-6 h-auto lg:hidden cursor-pointer"
          onClick={toggleMobileMenu}
        />
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg_header fixed top-0 left-0 w-full  h-fit z-50 flex flex-col items-center p-6">
          <button
            className="self-end mb-6 text-gray-500"
            onClick={toggleMobileMenu}
          >
            X {/* Close button for mobile menu */}
          </button>

          {location.pathname !== '/organization' && (
            <Link to="/" onClick={toggleMobileMenu}>Home</Link>
          )}

          <Link to="/how-it-works" onClick={toggleMobileMenu}>How It Works</Link>

          {(location.pathname === '/organization' || location.pathname === '/organization/message') && (
            <>
              <Link to="/organization" onClick={toggleMobileMenu}>Organizations</Link>
              <Link to="/organization/message" onClick={toggleMobileMenu}>Message</Link>
              <Link to="/organization/dashboard" onClick={toggleMobileMenu}>Dashboard</Link>
            </>
          )}

          {(location.pathname === '/volunteer' || location.pathname === '/volunteer/message') && (
            <>
              <Link to="/volunteer/message" onClick={toggleMobileMenu}>Message</Link>
              <Link to="/volunteer/dashboard" onClick={toggleMobileMenu}>Volunteer</Link>
            </>
          )}

          {location.pathname === '/' && (
            <>
              <button
                onClick={() => {
                  toggleModal();
                  toggleMobileMenu();
                }}
                type="button"
                className="nav_btn_color my-4 py-2 px-8 rounded-xl"
              >
                Log In
              </button>
              <button
                className="nav_btn_color py-2 px-8 rounded-xl"
                onClick={() => {
                  toggleSignUpModal();
                  toggleMobileMenu();
                }}
              >
                Sign Up
              </button>

            </>
          )}
        </div>
      )}

      {/* Login Modal */}
      {isModalOpen && (
        <div
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-gray-900 bg-opacity-50"
          onClick={toggleModal}
        >
          <div
            className="relative p-4 w-full max-w-xl max-h-full rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <LoginModal onLogin={closeModal} toggleSignUpModal={toggleSignUpModal} toggleAdminLogin={toggleAdminLogin} />
          </div>
        </div>
      )}

      {/* Sign-Up Modal */}
      {signUpModalOpen && (
        <div
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-gray-900 bg-opacity-50"
          onClick={toggleSignUpModal}
        >
          <div
            className="relative p-4 w-full max-w-xl max-h-full rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <SignUpModale onLogin={closeModal} toggleSignUpModal={toggleSignUpModal} toggleModal={toggleModal} toggleAdminLogin={toggleAdminLogin} />

          </div>
        </div>
      )}

      {/* Admin Login Modal */}
      {isAdminLoginOpen && (
        <div
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-gray-900 bg-opacity-50"
          onClick={toggleAdminLogin}
        >
          <div
            className="relative p-4 w-full max-w-xl max-h-full rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <AdminLoginModal onLogin={closeAdminLogin} />
          </div>
        </div>
      )}

      {/* Admin Sign-Up Modal */}
      {isAdminSignUpOpen && (
        <div
          className="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-full bg-gray-900 bg-opacity-50"
          onClick={toggleAdminSignUp}
        >
          <div
            className="relative p-4 w-full max-w-xl max-h-full rounded-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <AdminSignUpModale onLogin={closeAdminSignUp} />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Header;
